import { render, staticRenderFns } from "./UnitsToggleComponentNew.vue?vue&type=template&id=200f4044"
import script from "./UnitsToggleComponentNew.vue?vue&type=script&lang=js"
export * from "./UnitsToggleComponentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports